import api from './axiosInstance';

// Estado diario sobre la API judicial de Unholster.
// Backend: UnholsterDailyStateController (api/UnholsterDailyState).

export async function searchDailyState(query, signal) {
  const response = await api.post('/UnholsterDailyState/buscar', query, { signal });
  return response.data;
}

export async function getDocumentLink(documentoId, signal) {
  const response = await api.get(
    `/UnholsterDailyState/documentos/${encodeURIComponent(documentoId)}/link`,
    { signal }
  );
  return response.data;
}

export async function getDailyStateCatalogs(signal) {
  const response = await api.get('/UnholsterDailyState/catalogos', { signal });
  return response.data;
}

export async function getSyncStatus(signal) {
  const response = await api.get('/UnholsterDailyState/sincronizacion', { signal });
  return response.data;
}

export async function saveManagement(gestion, signal) {
  const response = await api.post('/UnholsterDailyState/gestion', gestion, { signal });
  return response.data;
}

export async function exportDailyStateExcel(query, signal) {
  const response = await api.post('/UnholsterDailyState/excel', query, {
    responseType: 'blob',
    signal,
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = `EstadosDiarios_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function getCaseMovements(caseId, signal) {
  const response = await api.get(
    `/UnholsterDailyState/causas/${caseId}/movimientos`,
    { signal }
  );
  return response.data;
}

export async function getDailyStatePanel(filas, signal) {
  const response = await api.get('/UnholsterDailyState/panel', {
    params: { filas },
    signal,
  });
  return response.data;
}
